export const ko = {
  'language.az': 'Azərbaycanca',
  'language.en': 'English',
  'language.hu': 'Magyar',
  'language.ko': '한국어',
  'language.pt': 'Português',
  'language.ru': 'Русский',
  'language.tr': 'Türkçe',
  'language.uz': 'Oʻzbek',

  'order': '주문 {order}',
  'amount': '{amount}',

  'card.sample.expiry': '유효기간',
  'card.sample.name': '홍길동',

  'card.pan': '카드 번호',
  'card.owner': '카드 소유자 이름',
  'card.expiry': '유효기간',
  'card.cvc': 'CVC',
  'card.captcha_text': '그림에 있는 문자를 입력하세요',

  'card.btn.pay': '결제하기',

  'card.error.pan.required': '항목을 입력하세요.',
  'card.error.pan.invalid': '카드 번호가 올바르지 않습니다.',
  'card.error.pan.whitelist': '다음 카드만 사용할 수 있습니다: {list}.',
  'card.error.name.invalid': '영문자, 공백, 마침표, 하이픈만 사용할 수 있습니다 (최대 30자).',
  'card.error.name.fullname': '이름과 성을 모두 입력하세요.',
  'card.error.name.required': '항목을 입력하세요.',
  'card.error.cvc.required': '항목을 입력하세요.',
  'card.error.cvc.invalid': '항목을 입력하세요.',
  'card.error.expiry.required': '항목을 입력하세요.',
  'card.error.expiry.month.invalid': '01부터 12까지의 값을 입력하세요.',
  'card.error.expiry.year.invalid': '올해 또는 이후 연도를 입력하세요.',
  'card.error.captcha_text.required': '항목을 입력하세요.',

  'card.protected.caption.title': '고객님의 정보는 안전하게 보호됩니다',
  'card.protected.caption.desc': '카드 정보는 보안 프로토콜을 통해 전송되며 온라인 상점이나 제3자에게 전달되지 않습니다. 모든 결제는 PCI DSS 표준을 준수하는 보안 처리 페이지에서 처리됩니다',

  'card.sending.preloader.title': '창을 닫거나 페이지를 새로 고치지 마세요',
  'card.sending.preloader.desc': '링크를 생성하고 있습니다. 몇 초에서 1분 정도 걸릴 수 있습니다.',

  'fatal_errors': '거절 사유:',

  'card.processing.1': '데이터 준비 중',
  'card.processing.2': '결제 가능 여부 확인 중',
  'card.processing.3': '결제 처리 중',

  'finish.pending': '결제 처리 중',
  'finish.pending.desc': '결제 요청이 접수되었습니다. 이 창을 닫고 상점으로 돌아가세요.',
  'finish.new': '결제 대기 중',
  'finish.new.desc': '결제 요청이 접수되었습니다. 이 창을 닫고 상점으로 돌아가세요.',
  'finish.complete': '결제가 완료되었습니다',
  'finish.complete.desc': '결제가 정상적으로 처리되었습니다. 이 창을 닫고 상점으로 돌아가세요.',
  'finish.failed': '결제가 거절되었습니다',
  'finish.failed.desc': '다시 결제하려면 상점으로 돌아가세요.',
  'finish.refunded': '결제가 환불되었습니다',
  'finish.refunded.desc': ' ',
  'finish.exception': '문제가 발생했습니다',
  'finish.exception.desc': ' ',

  'finish.debug_info': '고객지원 문의용 정보',
  'return.btn.return': '상점으로 돌아가기',

  'error.general': '문제가 발생했습니다... 다시 시도해 주세요.',
}
